(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prefurn-capisco-category"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('capisco-category')) customElements.define('capisco-category', class extends HTMLElement {
connectedCallback() {
 this.selects = [...this.querySelectorAll('[data-native-option]')];
 this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
 this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
 this.selects.forEach(select => select.addEventListener('change', () => this.update()));
 this.querySelector('.pc-request-details')?.addEventListener('toggle', () => { if(this.querySelector('.pc-request-details').open) this.querySelector('[data-request-fabric]').focus({preventScroll:true}); });
 this.colorImages = JSON.parse(this.querySelector('[data-color-images]')?.textContent || '{}');
 this.querySelectorAll('[data-color]').forEach(button => button.addEventListener('click', () => { this.selects[0].value = button.dataset.color; this.update(); }));
 this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => { this.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button))); this.querySelectorAll('[data-condition]').forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.condition !== button.dataset.filter; }); }));
 this.querySelectorAll('[data-choice-index]').forEach(button => button.addEventListener('click', () => { this.selects[Number(button.dataset.choiceIndex)].value = button.dataset.choiceValue; this.update(); }));
 this.update();
 const gas = this.querySelector('[data-request-gas]');
 const ring = this.querySelector('[data-request-ring]');
 const constrain = () => { const low = gas.value === '150 mm'; ring.options[1].disabled = low; if(low) ring.value = ring.options[0].value; };
 gas.addEventListener('change', constrain); constrain();
}
update() {
 const choices = this.selects.map(select => select.value);
 this.querySelectorAll('[data-choice-index]').forEach(button => button.setAttribute('aria-pressed',String(choices[Number(button.dataset.choiceIndex)] === button.dataset.choiceValue)));
 const summary = this.querySelector('[data-selection-summary]'); if(summary) summary.textContent = choices.map((value,index) => index === 1 ? (value.startsWith('Met') ? 'Met voetenring' : 'Zonder voetenring') : value.replace(/\s*\([^)]*\)/g,'').trim()).join(' · ');
 const variant = this.variants.find(variant => variant.options.every((value,index) => value === choices[index]));
 const link = this.querySelector('[data-product-link]');
 const base = this.querySelector('[data-product-url]').dataset.productUrl;
 link.href = variant ? `${base}?variant=${variant.id}` : base;
 this.querySelectorAll('[data-color]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === choices[0])));
 const image = this.querySelector('.pc-current-chair');
 if (image && this.colorImages?.[choices[0]]) { image.removeAttribute('srcset'); image.src = this.colorImages[choices[0]]; image.alt = choices[0] + ' — HÅG Capisco 8106'; }
 const status = this.querySelector('[data-stock]');
 status.textContent = variant?.available ? this.copy.stock : this.copy.unavailable;
 if (variant) this.querySelector('[data-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL',{style:'currency',currency: 'EUR'}).format(variant.price/100);
}
});

  } catch(e) { console.error(e); }
})();
})();
